import { render, staticRenderFns } from "./AgendaSearch.vue?vue&type=template&id=c909f70a&"
import script from "./AgendaSearch.vue?vue&type=script&lang=js&"
export * from "./AgendaSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports